export class ReferenceImageDeleteList {
  public ImageID: string = <string>'';
  public ReferenceImageFileName: string = <string>'';
}
